import styled from 'styled-components';

export const PaywallGuaranteePeriodStyles = styled.section<{
  theme?: 'dark-violet' | 'domination' | 'purple-gradient';
}>`
  body.dark & {
    --content-bg: rgba(128, 62, 255, 0.07);
    --protections-bg: #15072b;
    --protections-item-color: #fff;
    --protections-item-divider-bg: #bb8ab8;
    --platforms-icon-bg: #15072b;

    ${({ theme }) =>
      theme === 'dark-violet' &&
      `
      --content-bg: #553573;
      --protections-bg: #43285B;
      --protections-item-color: #fff;
      --protections-item-divider-bg: #fff;
      --platforms-icon-bg: #43285B;
    `}
  }

  --content-bg: #803eff0d;
  --protections-bg: #ede7f6;
  --protections-item-color: #857e8e;
  --protections-item-divider-bg: #857e8e;
  --platforms-icon-bg: #15072b;

  margin: 32px auto;
  max-width: 500px;
  width: 100%;
  padding: 0 16px;

  .local-shield {
    height: 27px;
    width: 26px;
    margin: 0 auto;
    display: block;
  }
`;

export const ProtectionIconWrapperStyles = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentStyles = styled.div`
  background: var(--content-bg);
  border-radius: 18px;
  padding: 20px 16px;
  width: 100%;

  .content-title {
    padding: 0 16px;
    margin: 16px 0;
  }

  .content-text {
    margin: 16px 0;

    a {
      color: inherit;
    }
  }
`;
